import {Col, Container, Row} from "react-bootstrap";
import React from "react";
import RightArrowButton from "./RightArrowButton";

export default function CompleteSwiftWiresButton(props) {
    const buttonTitle = props.buttonTitle??'Complete';
    const disabled = !!props.disabled;
    const handleClick = (e) => {
        if (disabled) {
            e.preventDefault();
            return;
        }
        props.onCompleteSwiftWiresClick(e);
    }
    return (<>
        <Container fluid className={props.isActionColBtn?"d-none" : "m-0 p-0"}>
            <Col className="text-nowrap d-none d-sm-block p-0 m-0">
                <a href="#" onClick={handleClick} className={disabled?"disabled":""} aria-disabled={disabled} style={disabled?{color:'#a3a3a3', pointerEvents:'none', cursor:'not-allowed'}:undefined}>{buttonTitle}</a>
            </Col>
            <Col className="text-nowrap d-block d-sm-none p-0 m-0">
                <Row onClick={handleClick} style={disabled?{opacity:0.5, pointerEvents:'none', cursor:'not-allowed'}:undefined}>
                    <Col xs={6} className={'py-2 pl-4'} style={{alignSelf: 'center'}}><p style={{float: 'left'}}>{buttonTitle}</p></Col>
                    <Col xs={6} className={'py-2 pr-2'} style={{alignSelf: 'center'}}> <RightArrowButton/></Col>
                    <Col xs={12} className={'py-2 pr-0 pl-3'}><hr/></Col>
                </Row>
            </Col>
        </Container>
        <Container fluid className={!props.isActionColBtn?"d-none":"m-0 p-0"}>
            <button disabled={disabled} className="btn btn-block td-btn-primary-light my-3" href="#" onClick={props.onCompleteSwiftWiresClick}>
                {buttonTitle}
            </button>
        </Container>
    </>)
}
